import { HtmlId } from '../enums/elementId';
import { debugInfo } from './debug';

/**
 * Can be used to mount patterns with debugInfo integrated
 *
 * @param wrapperId - Wrapper ID of the element.
 * @param create - Brix create function for the component.
 * @param props - Brix props of the pattern.
 * @returns Brix pattern component or
 * null if the element with the given ID is not found.
 */
export const mountComponent = <Pattern, Props>(
    wrapperId: HtmlId,
    create: (containerElement: HTMLElement, props: Props) => Pattern,
    props: Props,
): Pattern | null => {
    const containerEl = document.getElementById(wrapperId);

    if (!containerEl) {
        debugInfo('Couldn\'t mount element with id: ', wrapperId);

        return null;
    }

    return create(containerEl, props);
};
